export const GET_ALL_CHAUFFEUR_REQUEST = "GET_ALL_CHAUFFEUR_REQUEST";
export const GET_ALL_CHAUFFEUR_SUCCESS = "GET_ALL_CHAUFFEUR_SUCCESS";
export const GET_ALL_CHAUFFEUR_FAIL = "GET_ALL_CHAUFFEUR_FAIL";

export const ADD_CHAUFFEUR_REQUEST = "ADD_CHAUFFEUR_REQUEST";
export const ADD_CHAUFFEUR_SUCCESS = "ADD_CHAUFFEUR_SUCCESS";
export const ADD_CHAUFFEUR_FAIL = "ADD_CHAUFFEUR_FAIL";

export const UPDATE_CHAUFFEUR_REQUEST = "UPDATE_CHAUFFEUR_REQUEST";
export const UPDATE_CHAUFFEUR_SUCCESS = "UPDATE_CHAUFFEUR_SUCCESS";
export const UPDATE_CHAUFFEUR_FAIL = "UPDATE_CHAUFFEUR_FAIL";

export const DELETE_CHAUFFEUR_REQUEST = "DELETE_CHAUFFEUR_REQUEST";
export const DELETE_CHAUFFEUR_SUCCESS = "DELETE_CHAUFFEUR_SUCCESS";
export const DELETE_CHAUFFEUR_FAIL = "DELETE_CHAUFFEUR_FAIL";